module.exports = __webpack_public_path__ + "static/media/27wkndfirstpro.8493d113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/27wkndfirstpro.png
// module id = 122
// module chunks = 0